import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';
import Image from '../general/Image';
import { ROUTES } from '../../routes/RouteList';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  
  const menuItems = [
    { title: 'Hire Instantly', path: ROUTES.START_HIRING },
    { title: 'About', path: ROUTES.ABOUT_US },
    { title: 'Join as Developer', path: ROUTES.FIND_JOBS },
  ];

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.sidebar')) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div 
        className={`overlay ${isOpen ? 'show' : ''}`}
        onClick={onClose}
      />
      
      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="p-6">
          <div className="mb-8">
            <Image src={'/images/logo.png'} />
          </div>
          
          <nav>
            <ul className="space-y-4">
              {menuItems.map((item) => (
                <li key={item.title}>
                  <button
                    onClick={() => handleNavigation(item.path)}
                    className="w-full text-left block py-2 px-4 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
